/* unplugin-vue-components disabled */import { render } from "./member_welfare.vue?vue&type=template&id=c17a7b2a&scoped=true"
import script from "./member_welfare.vue?vue&type=script&lang=js"
export * from "./member_welfare.vue?vue&type=script&lang=js"

import "./member_welfare.vue?vue&type=style&index=0&id=c17a7b2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17a7b2a"]])

export default __exports__